import { botActions } from './bo';
export const api = (apiUri, token) => ({
  bo: () => botActions({
    apiUri,
    token
  })
});
//# sourceMappingURL=api.js.map